/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import { Grid, TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { AllManufacturer } from './TableHead';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  getBalanceThreshold,
  getDisputeAmount,
  getDramsInvStartQtr,
  getEarliestDrugQtr,
  getManufacturerList,
  getPlanTypeValues,
  getRebateProgrameList,
  getResultManufacturerSummary,
  setManufactureSummaryReport,
  setSearchInput,
} from '../Store/actions';
import {
  NO_DATA,
  REBATE_SELECT,
} from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export default function ReqManufacturerSummary(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    selectedPlanType,
    rebateProgramValue,
    rebateProgramList: rebateProgramListData,
    manufacturerList,
    selectedQuarterOption,
    rprtBalThresholdValue,
    selectRowIndex: selectRowIndexValue,
    earliestQtr,
    dramsInvoice,
    threshold,
    searchResult,
    disputeAmountForQuarter,
  } = useSelector((state) => state?.sharedState?.ManufacturerSummaryReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const quarterOptions = [
    {
      name: 'DRAMS Invoice Start Quarter',
      value: 'DRAMS Invoice Start Quarter',
    },
    {
      name: 'Earliest Quarter for Drug Details',
      value: 'Earliest Quarter for Drug Details',
    },
    { name: 'All', value: 'All Quarters' },
  ];
  const childRef = useRef(null);

  const [radioList, setRadioList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [selectList, setSelectList] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [rows, setRows] = React.useState([]);
  const [isSearchClicked, setIsSearchClicked] = React.useState(false);
  const [rprtQtrOptSelected, setRprtQtrOptSelected] = React.useState(
    selectedQuarterOption
  );
  const [rprtBalThreshold, setRprtBalThreshold] = React.useState(
    rprtBalThresholdValue
  );
  const [errorList, setErrorList] = React.useState(errors);
  const [selectedRow, setSelectedRow] = React.useState([]);
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);
  // API to get the plan type list
  React.useEffect(() => {
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  React.useEffect(() => {
    setRows(manufacturerList);
  }, [manufacturerList]);

  React.useEffect(() => {
    if (rebateProgram && rebateProgram != '-1') {
      dispatch(
        getManufacturerList({
          mfgTypeCd: planType === 'ST' || planType === 'FD' ? 'G' : 'C',
          rpc: rebateProgram,
        })
      );
    }
  }, [rebateProgram]);

  const rebatepgmDropdown = async (planType) => {
    // setErrorList([]);
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // on Changes rebateProgram API called
  React.useEffect(() => {
    dispatch(
      getDramsInvStartQtr({
        rebateProgCode: rebateProgram,
        allRpc: 0,
      })
    );
    dispatch(
      getEarliestDrugQtr({
        rebateProgramCd: rebateProgram,
      })
    );
    dispatch(
      getBalanceThreshold({
        rebateProgramCd: rebateProgram,
      })
    );
  }, [rebateProgram]);

  //remove no data error msg
  React.useEffect(() => {
    setErrorList([]);
  }, [planType, rebateProgram, rprtQtrOptSelected, rprtBalThreshold, fullScreenView]);

  // on selection changes , its sets the data for NDC table
  const onSelectionChanged = (e) => {
    setErrorList([]);
    const selectedRow = e.api?.getSelectedRows();
    setSelectedRow(selectedRow);
  };

  const handleSearchClick = (e, onDoubleClick, selectedRowOnDoubleClick) => {
    // setErrorList([]);
    let allErrors = [];
    if (rebateProgram === '-1' || !rebateProgram) {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    allErrors = [...allErrors];

    setErrorList(allErrors);
    if (allErrors.length === 0) {
      setIsSearchClicked(true);
      dispManufacturerSummary(onDoubleClick, selectedRowOnDoubleClick);
    }
  };

  const dispManufacturerSummary = (onDoubleClick, selectedRowOnDoubleClick) => {
    // setErrorList([]);
    if (onDoubleClick) {
      setSelectedRow(selectedRowOnDoubleClick);
    }
    const sortedRows = [...rows].sort((a, b) => {
      const aId = a.mfgId || '';
      const bId = b.mfgId || '';
      return aId.localeCompare(bId, undefined, { numeric: true });
    });
    let index = sortedRows.findIndex(
      (obj) =>
        obj.mfgId ===
        (selectedRow[0]?.mfgId || selectedRowOnDoubleClick[0]?.mfgId)
    );
    index = index === -1 ? 0 : index;
    let rebateProgramName =
      selectList?.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgramName = `${rebateProgramName?.rebateProgramCd} - ${
      rebateProgramName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        selectedQuarterOption: rprtQtrOptSelected,
        selectedRow: onDoubleClick ? selectedRowOnDoubleClick : selectedRow,
        rebateProgramValue: rebateProgram,
        rprtBalThresholdValue: rprtBalThreshold,
        selectRowIndex: index,
        selectedPlanType: planType,
        displayObj: {
          earliestQtr,
          dramsInvoice,
          threshold,
          selectedQuarterOption: rprtQtrOptSelected,
          rprtBalThresholdValue: rprtBalThreshold,
          selectedRow: onDoubleClick ? selectedRowOnDoubleClick : selectedRow,
          rebateProgramValue: rebateProgramName,
        },
      })
    );
    dispatch(setManufactureSummaryReport({}));
    dispatch(
      getResultManufacturerSummary({
        mfgId: onDoubleClick
          ? selectedRowOnDoubleClick[0]?.mfgId
          : selectedRow[0]?.mfgId,
        rpc: rebateProgram,
      })
    );
    dispatch(
      getDisputeAmount({
        mfgId: onDoubleClick
          ? selectedRowOnDoubleClick[0]?.mfgId
          : selectedRow[0]?.mfgId,
        rpc: rebateProgram,
      })
    );
  };
  useEffect(() => {
    if (
      Object.keys(searchResult).length > 0 &&
      disputeAmountForQuarter.length > 0 &&
      isSearchClicked
    ) {
      setIsSearchClicked(false);
      let rows = [];
      if (
        Object.keys(searchResult).length > 0 &&
        disputeAmountForQuarter.length > 0
      ) {
        const {
          manufactureSummaryReportFourthList: fourthList = [],
          manufactureSummaryReportMainList: mainList = [],
          manufactureSummaryReportSecondList: secondList = [],
          manufactureSummaryReportThirdList: thirdList = [],
          manufactureSummaryDisputeAmountForQuarterVOList:
            fifthList = disputeAmountForQuarter,
        } = searchResult;
        const secondListQtrObj = secondList?.reduce((acc, item) => {
          acc[item.qtr] = item;
          return acc;
        }, {});
        const thirdListQtrObj = thirdList?.reduce((acc, item) => {
          acc[item.targetQtr] = item;
          return acc;
        }, {});
        const fourthListQtrObj = fourthList?.reduce((acc, item) => {
          acc[item.invRecQtr] = item;
          return acc;
        }, {});
        const fifthListOtrObj = fifthList?.reduce((acc, item) => {
          acc[item.qtr] = item;
          return acc;
        }, {});

        rows = mainList?.map((item) => {
          return {
            ...item,
            ccAmountOwed: secondListQtrObj[item.qtr]?.ccAmountOwed
              ? parseFloat(secondListQtrObj[item.qtr]?.ccAmountOwed?.toFixed(2))
              : '0.00',
            cccalcCharge: secondListQtrObj[item.qtr]?.cccalcCharge
              ? parseFloat(secondListQtrObj[item.qtr]?.cccalcCharge?.toFixed(2))
              : '0.00',
            ccUnitChange: thirdListQtrObj[item.qtr]?.ccUnitChange
              ? parseFloat(thirdListQtrObj[item.qtr]?.ccUnitChange?.toFixed(2))
              : '0.00',
            ccInterest: fourthListQtrObj[item.qtr]?.ccInterest
              ? parseFloat(fourthListQtrObj[item.qtr]?.ccInterest?.toFixed(2))
              : '0.00',
            ccPrincipal: fourthListQtrObj[item.qtr]?.ccPrincipal
              ? parseFloat(fourthListQtrObj[item.qtr]?.ccPrincipal?.toFixed(2))
              : '0.00',
            disputedAmount: fifthListOtrObj[item.qtr]?.disputedAmount
              ? parseFloat(
                  fifthListOtrObj[item.qtr]?.disputedAmount?.toFixed(2)
                )
              : '0.00',
          };
        });
        rows = rows?.map((item) => {
          const adjustments =
            item.cccalcCharge - item.totCurrQtrAmt === 0
              ? '0.00'
              : parseFloat((item.cccalcCharge - item.totCurrQtrAmt).toFixed(2));
          return {
            ...item,
            adjustments,
          };
        });
        if (rprtQtrOptSelected === 'DRAMS Invoice Start Quarter') {
          const dramsYear = parseInt(dramsInvoice?.substring(2, 6));
          const dramsQuarter = dramsInvoice?.substring(0, 2);
          rows = rows?.filter((item) => {
            const year = parseInt(item.qtr.substring(2, 6));
            const quarter = item.qtr.substring(0, 2);

            return (
              year > dramsYear || (year === dramsYear && quarter > dramsQuarter)
            );
          });
        }
        if (rprtQtrOptSelected === 'Earliest Quarter for Drug Details') {
          const earliestYear = parseInt(earliestQtr.substring(2, 6));
          const earliestQuarter = earliestQtr.substring(0, 2);
          rows = rows?.filter((item) => {
            const year = parseInt(item.qtr.substring(2, 6));
            const quarter = item.qtr.substring(0, 2);

            return (
              year > earliestYear ||
              (year === earliestYear && quarter > earliestQuarter)
            );
          });
        }
        if (rprtBalThresholdValue) {
          rows = rows?.filter(
            (item) => Math.abs(item.ccAmountOwed) > Math.abs(threshold)
          );
        }
      }

      if (rows.length != 0) {
        const updateTabs =
          JSON.parse(localStorage.getItem('tabItemsData')) === null
            ? []
            : JSON.parse(localStorage.getItem('tabItemsData'));
        updateTabs.push({
          navTo: '/dispManufacturerSummary',
          value: 'Display Manufacturer Summary',
        });
        localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
        if (props?.history) {
          props.history.push({
            pathname: '/dispManufacturerSummary',
          });
          dispatch(clearReduxForFilterAndSort('/dispManufacturerSummary'));
        }
      } else {
        setErrorList([
          {
            field: 'NO_DATA',
            message: NO_DATA,
          },
        ]);
        // setTimeout(() => {
        //   setErrorList([]);
        // }, 5000);
      }
    }
  }, [searchResult, disputeAmountForQuarter]);

  const cellClickedListener = (e) => {
    setSelectedRow([e?.data]);
    handleSearchClick(null, true, [e?.data]);
  };
  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  if (errorMessages.length > 0) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      {!fullScreenView && (
        <>
          <CustomSeparator
            parent1="Detail Reports"
            parent2="Manufacturer Summary"
          />
          <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
          <div className="tab-body">
            <div className="row">
              <div className="col-4 frr-two-col-radio">
                <RadioGroupComponent
                  data-testid="ManufacturerSummary-plantype"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Plan Type"
                  required
                  optionList={radioList || []}
                  defaultValue={planType}
                  filterAction={(value) => {
                    setPlanType(value);
                    setRebateProgram('-1');
                    const errors = errorList.filter(
                      (error) => error.field !== 'rebateProgram'
                    );
                    setErrorList([...errors]);
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
              <div className="col-4">
                <>
                  <Fieldset label="Rebate Program" required>
                    <div style={{ marginTop: 18 }}>
                      <SelectBoxComponent
                        // disabled={allRebateProgram}
                        data-testid="ManufacturerSummary-RebateProgram"
                        id="filter-plan-by-radio-btn-action"
                        labelName="Rebate Program"
                        required
                        select
                        selectOne
                        optionList={selectList || []}
                        defaultValue={rebateProgram}
                        filterAction={(value) => {
                          setRebateProgram(value);
                          const errors = errorList.filter(
                            (error) => error.field !== 'rebateProgram'
                          );
                          setErrorList([...errors]);
                        }}
                        isError={
                          errorList.find(
                            (error) => error.field === 'rebateProgram'
                          )?.message
                        }
                      />
                    </div>
                  </Fieldset>
                </>
              </div>
              <div className="col-4 mt-5">
                <FormControlLabel
                  control={
                    <Checkbox
                      // defaultChecked
                      checked={rprtBalThreshold}
                      color="primary"
                      name="reportBalDueThreshold"
                      onBlur={() => {}}
                      onChange={() => {
                        setRprtBalThreshold(!rprtBalThreshold);
                      }}
                    />
                  }
                  label="Use Report Balance Due Threshold:"
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-8">
                <RadioGroupComponent
                  data-testid="Manufacturer-Summary-Quarter"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Report Quarter Option"
                  required
                  optionList={quarterOptions}
                  defaultValue={rprtQtrOptSelected}
                  filterAction={(value) => {
                    setRprtQtrOptSelected(value);
                  }}
                  className="log-batch-filter-radio frr-checkInvoiceRadio"
                />
              </div>
            </div>
            <div className="row" style={{ marginTop: 15 }}>
              <div className="btn-wrapper col-12">
                <Button
                  data-testid="ManufacturerSummary-search-btn"
                  onClick={handleSearchClick}
                  className="btn btn-success btn-search float-right"
                >
                  <SVGComponent iconName="Icon-search" /> Search
                </Button>
              </div>
            </div>
          </div>
        </>
      )}
      <TableGrid
        ref={childRef}
        onSelectionChanged={onSelectionChanged}
        rowData={rows}
        helpMessage
        // gridHeight={viewPortHeight_355}
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        cellClickedListener={cellClickedListener}
        gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
        columnDefs={AllManufacturer}
        rowSelection="single"
        selectRowIndex={selectRowIndexValue}
        rowMultiSelectWithClick
        data-testid="onEditingStopped"
        fileName="Manufacturer List"
        enterMovesDown
        suppressCellFocus
        singleClickEdit
        exportFile
        hideColumnsInPdf
      />
    </div>
  );
}
